import moment from "moment";
import { getCellStyle } from "../../Utils/DecideColor";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import StatusBadge from "../StatusBadge";
import { formatCellValue,formatDateForDisplay } from "../../Utils/UtilityFunctions";

export const taskColumns = (taskPath, isEIPEnabled) => {

  const buttonName = isEIPEnabled ? "Device ID" : "Customer ID";

  const formatTaskType = (taskType) => {
    return taskType
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  const columns = [
    // {
    //     accessorKey: "taskId",
    //     header: "Task ID",
    // },
    {
      accessorKey: "taskType",
      header: "Task Type",
      Cell: ({ cell }) => (
        <Box>
          {formatTaskType(cell.getValue())}
        </Box>
      )
    },
    {
      accessorKey: "internalStatus",
      header: "Internal Status",
      Cell: ({ cell }) => (
        <StatusBadge value={cell.getValue()} />
      ),
    },
    // {
    //   accessorKey: "provisioningStatus",
    //   header: "External Status",
    //   Cell: ({ cell }) => (
    //     <StatusBadge
    //       value={
    //         cell.getValue() === "NOT_ENABLED"
    //           ? "NOT ENABLED"
    //           : cell.getValue()
    //       }
    //     />
    //   ),
    // },
    {
      accessorKey: "taskTime",
      header: "Task Time",
      Cell: ({ cell }) => (
        <Box>
          {moment(cell.getValue()).format("DD MMM YYYY, HH:MM:SS")}
        </Box>
      )
    }
  ];
  if (taskPath === 'tasks') {
    columns.splice(1, 0, {
      accessorKey: "customerId",
      header: buttonName,
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    });
  }
  return columns;
};